const FEATURES = [
  {
    icon: 'ri-database-2-line',
    title: '海量资源',
    desc: '10万+影片库涵盖全球各类电影，从经典到最新，应有尽有。无论你喜欢什么类型，都能在这里找到心仪的影片。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质',
    desc: '全站提供1080P全高清画质，热门影片支持4K超清。采用H.265高效编码，画质清晰细腻，色彩还原真实。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放',
    desc: '全球CDN加速节点覆盖，智能选择最优线路。加载速度快，播放零缓冲，给您流畅丝滑的观影享受。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '专业内容团队每日更新50+部影片，紧跟全球影视热点。院线大片快速上线，经典佳作永不掉线。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-100 mb-3">
            特色优势
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            为什么超过百万影迷选择五姑娘影院
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {FEATURES.map((feat) => (
            <div
              key={feat.title}
              className="bg-background-200/40 rounded-lg border border-background-300/30 p-5 md:p-6 text-center group hover:border-primary-500/20 transition-all duration-300"
            >
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-500/10 text-primary-500 text-2xl">
                <i className={feat.icon}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-100 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}